import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

export const ReviewGrid = styled.div`
  column-count: 1;
  column-gap: '16px';

  ${media.md`
    column-count: 3;
    padding: 30px;
  `}
`

const ReviewOuter = styled.div`
  display: inline-block;
  background-color: ${({ theme }) => theme?.['-ds-core-50']?.value};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;

  h4 {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    line-height: 1.5;
    font-weight: 400;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-size']?.value};
    margin-bottom: 16px;
  }

  p {
    color: ${({ theme }) => theme?.['-ds-core-300']?.value};
    line-height: 1.5;
    font-weight: 300;
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-md']?.['font-size']?.value};
    margin-bottom: 12px;
  }
`

type ReviewProps = {
  name: React.ReactNode
  text: React.ReactNode
}

export const Review = ({ name, text }: ReviewProps) => {
  return (
    <ReviewOuter>
      <h4>{name}</h4>
      <p>&ldquo;{text}&rdquo;</p>
    </ReviewOuter>
  )
}
